/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

<template>
  <div v-bind:class="[amplifyUI.formSection, 'main-section', errored ? 'errored' : 'normal']" v-bind:data-test="auth.confirmSignUp.section">
    <div v-bind:class="[amplifyUI.sectionHeader, 'header-section']" v-bind:data-test="auth.confirmSignUp.headerSection">{{options.header}}</div>
    <div v-bind:class="amplifyUI.sectionBody" v-bind:data-test="auth.confirmSignUp.bodySection">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Username')}} *</div>
        <input spellcheck="false" v-bind:class="amplifyUI.input" v-model="options.username" name="username" :placeholder="$Amplify.I18n.get('Username')" autofocus v-bind:data-test="auth.confirmSignUp.usernameInput" />
      </div>
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Confirmation Code')}} *</div>
        <v-otp-input :ref="'otpInput'" :input-classes="'otp-input'" :separator="'&nbsp;'" :num-inputs="6" :should-auto-focus="true" :is-input-num="true" @on-change="handleOnChange"  @on-complete="handleOnComplete"  v-bind:class="amplifyUI.input" :placeholder="'enter the code'" v-bind:data-test="auth.confirmSignUp.confirmationCodeInput" />
        <div v-bind:class="['hint', 'forgot',  amplifyUI.hint]">
          {{$Amplify.I18n.get('Lost your code? ')}}
          <a v-bind:class="amplifyUI.a" v-on:click="resend" v-bind:data-test="auth.confirmSignUp.resendCodeLink">{{$Amplify.I18n.get('Resend Code')}}</a>
        </div>
      </div>
    </div>
    <div v-bind:class="[amplifyUI.sectionFooter, 'footer-section']">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <button :disabled="!(options.username && options.username.length >=4 && code && code.length >=6)" v-bind:class="amplifyUI.button" v-on:click="confirm" v-bind:data-test="auth.confirmSignUp.confirmButton">
          <geno-spinner :loading="flow" :text="$Amplify.I18n.get('Confirm')" :size="32"></geno-spinner></button>
      </span>
      <span v-bind:class="[amplifyUI.sectionFooterSecondaryContent, 'secondary-content']">
        {{$Amplify.I18n.get('Have an account? ')}}
        <a v-bind:class="amplifyUI.a" v-on:click="signIn" v-bind:data-test="auth.confirmSignUp.backToSignInLink">{{$Amplify.I18n.get('Back to Sign In')}}</a>
      </span>
    </div>
    <div class="error" v-if="false">
      {{ error }}
    </div>
  </div>
</template>

<script>
import AmplifyEventBus from '../../events/AmplifyEventBus';
import * as AmplifyUI from '@aws-amplify/ui';
import { auth } from '../../assets/data-test-attributes';

import otpInput from "@/components/vue-otp-input";



export default {
  name: 'ConfirmSignUp',
  props: ['confirmSignUpConfig'],
  data () {
    return {
        code: '',
        flow: false,
        error: '',
        errored: false,
        logger: {},
        amplifyUI: AmplifyUI,
        auth
    }
  },
  computed: {
    options() {
      const defaults = {
        username: '',
        header: this.$Amplify.I18n.get('Confirm Sign Up'),
      }
      return Object.assign(defaults, this.confirmSignUpConfig || {})
    }
  },
  mounted: function() {
    this.errored = false;
    this.logger = new this.$Amplify.Logger(this.$options.name)
      AmplifyEventBus.$emit('loginErrors', { source: 'confirmSignUp', error: this.error})
    if (!this.options.username) {
      return this.setError('Valid username not received.');
    };
  },
  methods: {
    confirm() {
        this.flow = true
        let username = this.options.user && this.options.user.username ? this.options.user.username : this.options.username
        this.$Amplify.Auth.confirmSignUp(username, this.code)
          .then(() => {
            this.flow = false;
            this.errored = false;
            this.logger.info('confirmSignUp success')
            this.signIn()
          })
          .catch(e => {
            this.flow = false;
      this.handleClearInput()
          this.setError(e)
          });
    },
    signIn: async function(event) {
      this.errored = false;
      let username = this.options.username || null
      let password = this.options.password || null
      if ( username && password ) {
      AmplifyEventBus.$emit('loginErrors', { source: 'signIn', error: ''})
      this.flow = true
      const that = this
      this.$Amplify.Auth.signIn(username, password)
        .then(async data => {
            this.flow = false
          this.logger.info('sign in success');
          if (data.challengeName === 'SMS_MFA' || data.challengeName === 'SOFTWARE_TOKEN_MFA') {
            this.user = data;
            AmplifyEventBus.$emit('localUser', data);
            AmplifyEventBus.$emit('authState', 'confirmSignIn');
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.user = data;
            AmplifyEventBus.$emit('localUser', data);
            AmplifyEventBus.$emit('authState', 'requireNewPassword');
          } else if (data.challengeName === 'MFA_SETUP') {
            this.user = data;
            AmplifyEventBus.$emit('localUser', data);
            //let user = await this.$Amplify.Auth.currentAuthenticatedUser()
            return AmplifyEventBus.$emit('authState', 'setMfa');
          } else {
            this.user = data;
            //return AmplifyEventBus.$emit('authState', 'setMfa');
            return AmplifyEventBus.$emit('authState', 'signedIn')
          }
        })
        .catch((e) => {
          console.log('signedInerror', e)
          this.flow = false
          if ((e.code && e.code === 'UserNotConfirmedException') || ( e.code && e.code == "UserLambdaValidationException" && e.message == "PreAuthentication failed with error 811.")){
            AmplifyEventBus.$emit('localUser', {username: this.options.username})
            AmplifyEventBus.$emit('authState', 'confirmSignIn')
          } else {
            if ( e.message == 'Request not allowed due to WAF block.' ) e.message = 'Request not allowed due to Firewall rules.\n\nIf you are using a VPN, you may browse the website, however login via a VPN is not allowed'
            this.setError(e);
            AmplifyEventBus.$emit('authState', 'signIn')
          } 
        });
        } else {
        //return to SignIn
        AmplifyEventBus.$emit('authState', 'signIn')
        }
    },
    resend() {
        this.flow = true
        this.$Amplify.Auth.resendSignUp(this.options.username)
            .then(() => {
            this.flow = false;
            this.errored = false;
              this.logger.info('resendSignUp success')
            })
            .catch(e => {
            this.flow = false;
            this.setError(e)
            });
    },
    setError(e) {
      this.errored = true;
      this.error = this.$Amplify.I18n.get(e.message || e);
      let loginErrors = e.message || e
      try {
      loginErrors = loginErrors.replace(/^.*failed with error/,'')
      }
      catch(err) {
      }
      AmplifyEventBus.$emit('loginErrors', { source: 'confirmSignUp', error: loginErrors})
      this.logger.error(this.error);
    },
    handleOnComplete(value) {
			this.code = value
      this.confirm()
    },
    handleOnChange(value) {
			this.code = value
    },
    handleClearInput() {
      this.$refs.otpInput.clearInput();
			this.code = null;
    },
  },
	components: {
	'v-otp-input': otpInput
	}
}
</script>
